// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6845c0f2","455":"7c89ab30","977":"d9745d62"}[chunkId] + ".chunk.js";
};